module.exports = __webpack_public_path__ + "img/metaMaskInstallationStep_8.02de514.png";